const ABProcessTaskServiceAccountingFPCloseCore = require("../../../core/process/tasks/ABProcessTaskServiceAccountingFPCloseCore");
module.exports = class ABProcessTaskServiceAccountingFPClose extends (
   ABProcessTaskServiceAccountingFPCloseCore
) {};
